
import Vue from "vue"
import SVGIcon from '@/components/svgIcon/index.vue'

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
export default Vue.extend({
	props: {
		placeholder: {
			default: "loading"
		}
	},
	components: {
		SVGIcon
	},
	computed: {
		icon: () => faSpinner
	}
})
